@if (!loader().candidate && visibleCandidates().length == 0) {
<div class="h-full overflow-hidden p-8 pt-[88px] mt-6 md:mt-0">
  <!-- Main Container -->
  <div class="max-w-6xl mx-auto">
    <!-- Header -->
    <div class="mb-8">
      <h1 class="text-3xl font-bold text-gray-900">Interview Reviews</h1>
      <p class="text-gray-600 mt-2">Review candidate interviews and make hiring decisions</p>
    </div>

    <!-- Empty State Card -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-12">
      <div class="flex flex-col items-center justify-center text-center">
        <!-- Icon -->
        <div class="w-24 h-24 mb-6 rounded-full bg-indigo-50 flex items-center justify-center">
          <svg class="w-12 h-12 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
          </svg>
        </div>

        <!-- Text Content -->
        <h2 class="text-2xl font-semibold text-gray-900 mb-3">
          No Interviews to Review
        </h2>
        <p class="text-gray-600 max-w-md mb-8">
          When new candidate interviews are submitted, they'll appear here for your review.
          You'll be able to watch interview recordings and evaluate candidates.
        </p>
      </div>
    </div>
  </div>
</div>
} @else {
@if (loader().candidate) {
<!-- Loader -->
<div class="min-h-svh col-span-4 flex items-center justify-center md:min-h-[calc(100dvh-72px)]">
  <mat-spinner diameter="50"></mat-spinner>
</div>
} @else {
<div class="md:grid grid-cols-8">
  <div
    class="md:mx-auto fixed md:static md:w-full inset-0 col-span-4 max-h-[100dvh] md:max-h-[calc(100dvh-122px)] overflow-y-hidden">
    <!-- Main Container -->
    <div id="scroll-container" #scrollContainer
      class="h-[100dvh] md:max-h-[calc(100dvh - 128px)] w-full overflow-y-scroll snap-y snap-mandatory">
      <div tourAnchor="ai"
        class="max-w-[100vw] z-50 flex md:hidden sticky top-[70px] md:top-0 md:border-b w-full bg-[#F3F4F6]">
        <!-- Dislike Button -->
        <button (click)="updateStatus('rejected')" [disabled]="loader().action"
          class="w-full flex items-center justify-center py-3 text-red-500 font-extralight bg-transparent border-r"
          [ngClass]="visibleCandidates()[currentIndex()]?.status == 'rejected' ? '!bg-red-500 !text-white' : 'hover:bg-red-500 hover:text-white'">
          <mat-icon>close</mat-icon>
          Reject
        </button>
        <button (click)="updateStatus('hold')" [disabled]="loader().action"
          class="w-full flex items-center justify-center py-3 text-yellow-500 font-extralight bg-transparent border-r"
          [ngClass]="visibleCandidates()[currentIndex()]?.status == 'hold' ? '!bg-yellow-500 !text-white' : 'hover:bg-yellow-500 hover:text-white'">
          <mat-icon>pause</mat-icon>
          Hold
        </button>
        <!-- Pass to Next Button -->
        <button (click)="updateStatus('accepted')" [disabled]="loader().action"
          class="w-full flex items-center justify-center py-3 text-blue-500 font-extralight bg-transparent"
          [ngClass]="visibleCandidates()[currentIndex()]?.status == 'accepted' ? '!bg-blue-500 !text-white' : 'hover:bg-blue-500 hover:text-white'">
          Pass
          <mat-icon>keyboard_arrow_right</mat-icon>

        </button>
      </div>
      <!-- Counter  -->
      <div class="absolute top-[8rem] md:top-2 md:left-[46%] md:w-fit right-2 bg-black/60 text-white text-sm px-3 py-1 rounded-lg z-10">
        {{ currentIndex() + 1 }}/{{ candidates().length }}
      </div>

      @for(candidate of visibleCandidates();track candidate?.candidate_id;let i = $index;let last = $last) {
      <div class="snap-start h-full relative" [index]="i" [appInView]="last" (inView)="loadMore($event)">

        <!-- Video Interview Section -->
        <div class="h-[100dvh] md:max-h-[calc(100dvh-118px)] flex flex-col items-center video-card">
          @if (candidate.resume_analysis?.interview_video_url) {
          @defer (when i === currentIndex()) {
          <app-vjs-player class="h-full md:h-[calc(100dvh-151px)]" [index]="i" [currentIndex]="currentIndex()"
            [video]="candidate.resume_analysis?.interview_video_url">
          </app-vjs-player>
          } @loading {
          <div class="w-full flex items-center justify-center flex-col h-[calc(100dvh-72px)] md:h-[calc(100dvh-128px)]">
            <mat-spinner diameter="40"></mat-spinner>
            <p class="mt-4 text-gray-600">Loading video...</p>
          </div>
          } @placeholder {
          <div
            class="w-full bg-black md:bg-white text-white md:text-black/80 flex items-center justify-center flex-col h-[calc(100dvh-72px)] md:h-[calc(100dvh-128px)]">
            <mat-icon>videocam_off</mat-icon>
            <p class="text-gray-600 text-xl">No video available</p>
          </div>
          }
          }
        </div>
      </div>
      }

      <div class="w-full md:w-[50%] fixed bottom-0 p-4 bg-[#F3F4F6] md:text-black/80 md:border-t">
        <div class="flex items-center gap-1">
          <mat-icon class="text-black/80 scale-150 drop-shadow-lg mr-2">account_circle</mat-icon>
          <div>
            <h3 class="text-black/80 font-semibold max-w-[90%] truncate">{{
              visibleCandidates()[currentIndex()]?.candidate_name }}</h3>
            @if(visibleCandidates()[currentIndex()]?.resume_analysis?.transcription_analysis?.rating) {
            <p class="text-black/80 text-sm">{{
              visibleCandidates()[currentIndex()]?.resume_analysis?.transcription_analysis?.rating * 10 }}% Match Rate
            </p>
            }
          </div>
          <div tourAnchor="do" class="flex flex-col ml-auto gap-1 items-center">
            <button mat-flat-button color="primary" (click)="openBottomSheet('download')">
              Download
              <mat-icon class="text-md">download</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="absolute right-4 bottom-32 flex flex-col items-center space-y-4">
        <button tourAnchor="cad" mat-icon-button (click)="openBottomSheet('candidate')"
          class="bg-gray-800/50 !text-white drop-shadow-lg md:!hidden">
          <mat-icon class="text-md">person</mat-icon>
        </button>

        <button tourAnchor="crd" mat-icon-button (click)="openBottomSheet('career')"
          class="bg-gray-800/50 !text-white drop-shadow-lg md:!hidden">
          <mat-icon class="text-md">work</mat-icon>
        </button>

        <button tourAnchor="ma" mat-icon-button (click)="openBottomSheet('candidate-analysis')"
          class="bg-gray-800/50 !text-white drop-shadow-lg md:!hidden">
          <mat-icon class="text-md">analytics</mat-icon>
        </button>

        @if(visibleCandidates()[currentIndex()]?.resume_analysis?.transcription_analysis?.rating) {
        <button tourAnchor="aa" mat-icon-button (click)="openBottomSheet('audio-analysis')"
          class="bg-gray-800/50 !text-white drop-shadow-lg md:!hidden">
          <mat-icon class="text-md">graphic_eq</mat-icon>
        </button>
        }
      </div>
    </div>
  </div>

  <div
    class="col-span-4 hidden md:flex flex-col bg-[#F3F4F6] max-h-[100dvh] md:max-h-[calc(100dvh-73px)] overflow-y-auto scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-gray-300 md:border-l">
    <div class="button-container max-w-[100vw] md:max-w-100 z-10 hidden md:flex w-full bg-[#212529] md:!bg-[#F3F4F6] border-b sticky top-0">
      <!-- Dislike Button -->
      <button (click)="updateStatus('rejected')" [disabled]="loader().action"
        class="w-full flex items-center justify-center py-3 text-red-500 font-extralight bg-transparent border-r"
        [ngClass]="visibleCandidates()[currentIndex()]?.status == 'rejected' ? '!bg-red-500 !text-white' : 'hover:bg-red-500 hover:text-white'">
        <mat-icon>close</mat-icon>
        Reject
      </button>
      <!-- Hold Button  -->
      <button (click)="updateStatus('hold')" [disabled]="loader().action"
        class="w-full flex items-center justify-center py-3 text-yellow-500 font-extralight bg-transparent border-r"
        [ngClass]="visibleCandidates()[currentIndex()]?.status == 'hold' ? '!bg-yellow-500 !text-white' : 'hover:bg-yellow-500 hover:text-white'">
        <mat-icon>pause</mat-icon>
        Hold
      </button>
      <!-- Pass Button -->
      <button (click)="updateStatus('accepted')" [disabled]="loader().action"
        class="w-full flex items-center justify-center py-3 text-blue-500 font-extralight bg-transparent"
        [ngClass]="visibleCandidates()[currentIndex()]?.status == 'accepted' ? '!bg-blue-500 !text-white' : 'hover:bg-blue-500 hover:text-white'">
        Pass
        <mat-icon>keyboard_arrow_right</mat-icon>

      </button>
    </div>
    <candidate-details [candidate]="candidates()[currentIndex()]" class="col-span-2"></candidate-details>
    <career-details [candidate]="candidates()[currentIndex()]" class="col-span-2"></career-details>
    <candidate-analysis [candidate]="candidates()[currentIndex()]" class="col-span-2"></candidate-analysis>
    @if(visibleCandidates()[currentIndex()]?.resume_analysis?.transcription_analysis?.rating) {
    <audio-analysis [candidate]="candidates()[currentIndex()]" class="col-span-2"></audio-analysis>
    }
  </div>
</div>
}
}
<tour-step-template></tour-step-template>